import { render, staticRenderFns } from "./HeaderAndButtons.vue?vue&type=template&id=1b2f7e0f&scoped=true&"
import script from "./HeaderAndButtons.vue?vue&type=script&lang=js&"
export * from "./HeaderAndButtons.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAndButtons.css?vue&type=style&index=0&id=1b2f7e0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2f7e0f",
  null
  
)

export default component.exports